import React, { useContext, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import api from '../services/api';
import { AuthContext } from '../context/AuthContext';
import { Button } from '../components/ui';

export default function Register() {
  const { login } = useContext(AuthContext);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [name, setName] = useState('');
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);
    try {
      const res = await api.register({ email, password, name });
      if (res?.error) throw new Error(res.error);
      const lr = await login(email, password);
      if (lr.ok) {
        navigate('/create', { replace: true });
      } else {
        navigate('/login', { replace: true });
      }
    } catch (e2) {
      setError(e2.message || 'Registration failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-panel">
      <p className="loud-eyebrow" style={{ marginBottom: 16 }}>Get started free</p>
      <h2>Create account</h2>
      <p className="auth-sub">Then make your first voice ad in about a minute.</p>
      <form onSubmit={onSubmit}>
        <label htmlFor="reg-name">Name (optional)</label>
        <input
          id="reg-name"
          name="name"
          value={name}
          onChange={(e) => setName(e.target.value)}
          type="text"
          autoComplete="name"
        />

        <label htmlFor="reg-email">Email</label>
        <input
          id="reg-email"
          name="email"
          autoComplete="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          type="email"
          required
        />

        <label htmlFor="reg-password">Password</label>
        <input
          id="reg-password"
          name="password"
          autoComplete="new-password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          type="password"
          required
        />

        <Button type="submit" fullWidth size="lg" loading={loading} disabled={loading}>
          {loading ? 'Creating account…' : 'Create account'}
        </Button>
      </form>
      {error && <p className="auth-error" role="alert">{error}</p>}
      <p style={{ textAlign: 'center', margin: '16px 0 0', color: 'var(--color-text-muted)', fontSize: 14 }}>
        Already have an account?{' '}
        <Link to="/login" style={{ fontWeight: 700 }}>
          Sign in
        </Link>
      </p>
    </div>
  );
}
